var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFasciaSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Size-logo-16px"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size-logo-16px",
    clipPath: "url(#clip-Size-logo-16px)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-18.98 -28.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M78.9,243.484c.016.938.761,1.383,1.76,1.383.822,0,1.775-.345,1.775-1.291,0-.784-.645-1.015-1.283-1.161s-1.291-.207-1.291-.637c0-.346.468-.407.722-.407.384,0,.73.115.807.53H82.3c-.108-.883-.845-1.221-1.66-1.221-.722,0-1.66.269-1.66,1.138,0,.807.63,1.037,1.276,1.176s1.276.2,1.3.661-.554.523-.884.523c-.469,0-.853-.184-.9-.692Z",
    transform: "translate(-59.898 -204.989)",
    fill: "#ff600b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 0.876,
    height: 0.83,
    transform: "translate(22.785 34.533)",
    fill: "#ff600b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 0.876,
    height: 3.973,
    transform: "translate(22.785 35.788)",
    fill: "#ff600b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M115.719,242.122h2.2l-2.2,2.666v.615h3.393v-.692h-2.286l2.275-2.667v-.615h-3.382Z",
    transform: "translate(-91.832 -205.643)",
    fill: "#ff600b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M169.513,230.7v-.156a.653.653,0,0,1,.693-.7.49.49,0,0,1,.523.5c0,.41-.314.582-.644.811a1.3,1.3,0,0,0-.653,1.139v.409h1.272c.008-.491.113-.614.532-.893.613-.393.991-.68.991-1.474a1.793,1.793,0,0,0-2.014-1.672,1.939,1.939,0,0,0-2.111,2.04Zm-.075,3.69H170.7V233.11h-1.262Z",
    transform: "translate(-137.249 -194.629)",
    fill: "#ff600b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M143.8,241.994h-2.021a1.014,1.014,0,0,1,2.021,0m-.986-1.622a1.955,1.955,0,0,0-1.922,2.1,1.885,1.885,0,0,0,1.945,2.09,1.74,1.74,0,0,0,1.8-1.352h-.83a.921.921,0,0,1-.968.66,1.057,1.057,0,0,1-1.069-1.176h2.921a1.96,1.96,0,0,0-1.875-2.321",
    transform: "translate(-113.663 -204.722)",
    fill: "#ff600b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFasciaSize);
export default __webpack_public_path__ + "static/media/logo-fascia-size.d84fdee5.svg";
export { ForwardRef as ReactComponent };